// extracted by mini-css-extract-plugin
module.exports = {"MadeEasyInfo":"MadeEasyInfo_MadeEasyInfo__2kSaY"};